import { pathJoin } from 'src/reducers/routing/utils'

export const createLocationRouteMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  containers: pathJoin(prefix)('containers').chain,
  'service-log': pathJoin(prefix)('service-log').chain,
})
